import React, { useEffect, useState } from "react";
import { DashboardIntro } from "../components/Dashboard/DashboardIntro";
import { DashboardBasicDetails } from "../components/Dashboard/DashboardBasicDetails";
import ComponentHeader from "../components/Common/OtherElements/ComponentHeader";
import { DashboardRecentActivity } from "../components/Dashboard/DashboardTopContacts";
import { getDashboardSummary } from "../services/dashboardService";
import { handleErrors } from "../utils/errorHandler";

const EMPTY_SUMMARY = {
  totalContactRequests: 0,
  totalCareerApplications: 0,
  totalCareersPosted: 0,
  recentContactRequests: [],
  recentCareerApplications: [],
};

export const DashboardPage = () => {
  const [summary, setSummary] = useState(EMPTY_SUMMARY);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadSummary = async () => {
      setLoading(true);
      try {
        const result = await getDashboardSummary();
        setSummary({
          totalContactRequests: result?.totalContactRequests || 0,
          totalCareerApplications: result?.totalCareerApplications || 0,
          totalCareersPosted: result?.totalCareersPosted || 0,
          recentContactRequests: result?.recentContactRequests || [],
          recentCareerApplications: result?.recentCareerApplications || [],
        });
      } catch (error) {
        handleErrors(error);
      } finally {
        setLoading(false);
      }
    };

    loadSummary();
  }, []);

  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">
          <ComponentHeader title="Dashboard" />
          <div className="row">
            <div className="col">
              <div className="h-100">
                <DashboardIntro />
                <DashboardBasicDetails
                  totalContactRequests={summary.totalContactRequests}
                  totalCareerApplications={summary.totalCareerApplications}
                  totalCareersPosted={summary.totalCareersPosted}
                />
                <DashboardRecentActivity
                  contacts={summary.recentContactRequests}
                  applications={summary.recentCareerApplications}
                  loading={loading}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
